import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function ComparisonTable() {
  const comparisons = [{
    feature: 'Vleesgehalte',
    anifit: '90-99% vleesgehalte',
    regular: 'Max 30-60% vlees'
  }, {
    feature: 'Kwaliteit',
    anifit: 'Levensmiddelkwaliteit vlees',
    regular: 'Vaak vleesmeel/bijproducten'
  }, {
    feature: 'Conservering',
    anifit: 'Geen conserveringsmiddelen',
    regular: 'Conserveringsmiddelen nodig'
  }, {
    feature: 'Smaak',
    anifit: 'Geen smaakversterkers',
    regular: 'Lokstoffen toegevoegd'
  }, {
    feature: 'Transparantie',
    anifit: 'Exacte ingrediënten op etiket',
    regular: 'Vage omschrijvingen'
  }, {
    feature: 'Herkomst',
    anifit: 'Zweeds kwaliteitsvlees',
    regular: 'Herkomst vaak onduidelijk'
  }];
  return <section className="py-20 bg-gray-50" data-id="element-29">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-30">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-31">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4" data-id="element-32">
            Waarom Specifiek Anifit?
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-33">
            Je hebt waarschijnlijk al gelezen over de voordelen. Hier de
            kernpunten op een rij:
          </p>
        </motion.div>

        <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-lg overflow-hidden" data-id="element-34">
          <div className="grid grid-cols-3 bg-gray-900 text-white p-4 sm:p-6 text-sm sm:text-lg font-bold" data-id="element-35">
            <div className="text-gray-400 font-normal text-xs sm:text-base flex items-center" data-id="element-36">
              KENMERK
            </div>
            <div className="text-[#4DBFB8] flex items-center justify-center" data-id="element-37">
              ANIFIT
            </div>
            <div className="text-gray-400 flex items-center justify-center text-center" data-id="element-38">
              REGULIER NATVOER
            </div>
          </div>

          <div className="divide-y divide-gray-100" data-id="element-39">
            {comparisons.map((row, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="grid grid-cols-3 p-4 sm:p-6 hover:bg-gray-50 transition-colors" data-id="element-40">
                <div className="font-medium text-gray-900 flex items-center text-sm sm:text-base" data-id="element-41">
                  {row.feature}
                </div>

                <div className="flex flex-col sm:flex-row items-center justify-center text-center gap-2" data-id="element-42">
                  <div className="w-6 h-6 rounded-full bg-[#4DBFB8]/10 flex items-center justify-center flex-shrink-0" data-id="element-43">
                    <Check className="w-4 h-4 text-[#4DBFB8]" data-id="element-44" />
                  </div>
                  <span className="text-sm text-gray-700 font-medium" data-id="element-45">
                    {row.anifit}
                  </span>
                </div>

                <div className="flex flex-col sm:flex-row items-center justify-center text-center gap-2" data-id="element-46">
                  <div className="w-6 h-6 rounded-full bg-red-100 flex items-center justify-center flex-shrink-0" data-id="element-47">
                    <X className="w-4 h-4 text-red-500" data-id="element-48" />
                  </div>
                  <span className="text-sm text-gray-500" data-id="element-49">{row.regular}</span>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}